import useAction from '../../utils/use-action';

const useAddItem = useAction;

export default useAddItem;
